import { html } from "lit-html"
import TagList from "./tag-list"

const AgencyRow = ({ name, tags, url, scraper_names }) => html`
  <div class="agency p-3 pb-0 relative flex flex-row flex-wrap">
    <div class="min-h-11 p-3 order-1">
      <div class="mb-2">
        <span
          class="tooltip-icon w-8 h-8 source-indicator-border inline-flex items-center justify-center"
        >
          ${scraper_names && scraper_names.length > 0
            ? html`<i class="cb fa-scraper-robot w-6 text-blue"></i>
                <span class="tooltip-icon-tooltiptext"
                  >Agency added by scrapers</span
                >`
            : html`<span class="font-bold text-blue">M</span>
                <span class="tooltip-icon-tooltiptext"
                  >Agency manually added (no scraper)</span
                >`}
        </span>
      </div>
      <a href=${url}>${name} </a>
      <p>${TagList(tags)}</p>
    </div>
    <hr class="divider m-3 mb-0 order-10" />
  </div>
`

export default AgencyRow
